// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AddPop.css - Final Precision Match */

:root {
  --bg-main: #f3f4f6;
  --card-bg: #1e293b;
  --input-bg: #0f172a;
  --primary-blue: #3b82f6; 
  --cancel-bg: #475569; 
  --border-color: #334155;
  --text-label: #94a3b8;
  --text-white: #ffffff;
}

/* কন্টেইনার: যা পুরো স্ক্রিন সাদা/গ্রে রাখবে এবং কার্ডকে উপরে রাখবে */
.add-pop-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  background-color: var(--bg-main) !important;
  padding: 40px 20px;
  font-family: 'Inter', sans-serif;
  box-sizing: border-box;
}

/* মেইন কার্ড */
.add-pop-card {
  background-color: var(--card-bg);
  width: 100%;
  max-width: 650px;
  padding: 25px 30px;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  border: 1px solid var(--border-color);
}

.add-pop-form-title {
  color: var(--text-white);
  font-size: 1.4rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 25px;
  letter-spacing: 0.5px;
}

.add-pop-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* গ্রিড লেআউট: ২য় ছবির মতো ইনপুট পাশাপাশি রাখার জন্য */
.add-pop-grid-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.add-pop-input-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.add-pop-input-group label {
  color: var(--text-label);
  font-size: 13px;
  font-weight: 500;
  margin-left: 2px;
}

.add-pop-input-group input,
.add-pop-input-group select,
.add-pop-input-group textarea {
  background-color: var(--input-bg);
  color: var(--text-white);
  border: 1px solid var(--border-color);
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.add-pop-input-group input:focus,
.add-pop-input-group select:focus {
  border-color: var(--primary-blue);
}

/* বাটন এরিয়া */
.add-pop-button-group {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

.add-pop-btn-cancel {
  flex: 1 1;
  background-color: var(--cancel-bg);
  color: white;
  border: none;
  padding: 12px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  font-size: 15px;
}

.add-pop-btn-submit {
  flex: 2 1; /* সংরক্ষণ বাটনটি বড় হবে */
  background-color: var(--primary-blue);
  color: white;
  border: none;
  padding: 12px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  font-size: 15px;
  transition: background 0.2s;
}

.add-pop-btn-submit:hover {
  background-color: #2563eb;
}

/* মোডাল স্টাইল */
.add-pop-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.add-pop-modal-box {
  background: white;
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  width: 350px;
  box-shadow: 0 15px 40px rgba(0,0,0,0.2);
}

.add-pop-modal-box h3 { color: #1e293b; margin-bottom: 15px; }

/* Responsive */
@media (max-width: 600px) {
  .add-pop-grid-row { grid-template-columns: 1fr; }
}`, "",{"version":3,"sources":["webpack://./src/components/InfoManage/AddPop.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,iCAAiC;EACjC,wBAAwB;EACxB,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO,EAAE,0BAA0B;EACnC,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,uCAAuC;AACzC;;AAEA,wBAAwB,cAAc,EAAE,mBAAmB,EAAE;;AAE7D,eAAe;AACf;EACE,oBAAoB,0BAA0B,EAAE;AAClD","sourcesContent":["/* AddPop.css - Final Precision Match */\n\n:root {\n  --bg-main: #f3f4f6;\n  --card-bg: #1e293b;\n  --input-bg: #0f172a;\n  --primary-blue: #3b82f6; \n  --cancel-bg: #475569; \n  --border-color: #334155;\n  --text-label: #94a3b8;\n  --text-white: #ffffff;\n}\n\n/* কন্টেইনার: যা পুরো স্ক্রিন সাদা/গ্রে রাখবে এবং কার্ডকে উপরে রাখবে */\n.add-pop-container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 100vh;\n  background-color: var(--bg-main) !important;\n  padding: 40px 20px;\n  font-family: 'Inter', sans-serif;\n  box-sizing: border-box;\n}\n\n/* মেইন কার্ড */\n.add-pop-card {\n  background-color: var(--card-bg);\n  width: 100%;\n  max-width: 650px;\n  padding: 25px 30px;\n  border-radius: 10px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  border: 1px solid var(--border-color);\n}\n\n.add-pop-form-title {\n  color: var(--text-white);\n  font-size: 1.4rem;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 25px;\n  letter-spacing: 0.5px;\n}\n\n.add-pop-form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n/* গ্রিড লেআউট: ২য় ছবির মতো ইনপুট পাশাপাশি রাখার জন্য */\n.add-pop-grid-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.add-pop-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.add-pop-input-group label {\n  color: var(--text-label);\n  font-size: 13px;\n  font-weight: 500;\n  margin-left: 2px;\n}\n\n.add-pop-input-group input,\n.add-pop-input-group select,\n.add-pop-input-group textarea {\n  background-color: var(--input-bg);\n  color: var(--text-white);\n  border: 1px solid var(--border-color);\n  padding: 10px 12px;\n  border-radius: 6px;\n  font-size: 14px;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color 0.2s;\n}\n\n.add-pop-input-group input:focus,\n.add-pop-input-group select:focus {\n  border-color: var(--primary-blue);\n}\n\n/* বাটন এরিয়া */\n.add-pop-button-group {\n  display: flex;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.add-pop-btn-cancel {\n  flex: 1;\n  background-color: var(--cancel-bg);\n  color: white;\n  border: none;\n  padding: 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.add-pop-btn-submit {\n  flex: 2; /* সংরক্ষণ বাটনটি বড় হবে */\n  background-color: var(--primary-blue);\n  color: white;\n  border: none;\n  padding: 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 15px;\n  transition: background 0.2s;\n}\n\n.add-pop-btn-submit:hover {\n  background-color: #2563eb;\n}\n\n/* মোডাল স্টাইল */\n.add-pop-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.add-pop-modal-box {\n  background: white;\n  padding: 30px;\n  border-radius: 12px;\n  text-align: center;\n  width: 350px;\n  box-shadow: 0 15px 40px rgba(0,0,0,0.2);\n}\n\n.add-pop-modal-box h3 { color: #1e293b; margin-bottom: 15px; }\n\n/* Responsive */\n@media (max-width: 600px) {\n  .add-pop-grid-row { grid-template-columns: 1fr; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
